import { defaultTheme } from '@3plearning/react-components';
import palette from './palette';

export default {
  ...defaultTheme.typography,
  title: {
    size: '30px',
    weight: 500
  },
  subtitle: {
    size: '16px',
    weight: 600,
    colour: palette.primary.main
  },
  heading: {
    size: '21px'
  },
  modalTitle: {
    size: '20px'
  },
  body: {
    size: '14px'
  },
  button: {
    size: '11px'
  },
  info: {
    size: '10px'
  },
  cell: {
    size: '9px'
  }
};



// WEBPACK FOOTER //
// ./themes/upf-theme/typography.js